import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localizePath } from '../../seo/site';

export default function LocalizedLink({ to, ...props }) {
  const { i18n } = useTranslation();
  const target = typeof to === 'string' ? localizePath(to, i18n.language) : {
    ...to, pathname: to.pathname ? localizePath(to.pathname, i18n.language) : to.pathname
  };
  return <Link to={target} {...props} />;
}
